/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_No_Folder_Selected_ToastInputs */



/**
* | output |
* | --- |
* | "Please select an export folder" |
*
* @param {Image_Export_No_Folder_Selected_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_no_folder_selected_toast = /** @type {((inputs?: Image_Export_No_Folder_Selected_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_No_Folder_Selected_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner un dossier d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie einen Exportordner aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una cartella di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите папку для экспорта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione una carpeta de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择导出文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートフォルダを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया निर्यात फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, selecione uma pasta de exportação.")
	return /** @type {LocalizedString} */ ("Please select an export folder")
});